import { FC, KeyboardEventHandler, useCallback, useId } from 'react';

interface CheckboxProps {
  checked: boolean;
  onChange?: (value: boolean) => void;
  label?: string;
  className?: string;
  id?: string;
  disabled?: boolean;
}

const Checkbox: FC<CheckboxProps> = ({
  checked,
  onChange,
  label,
  className = '',
  id: customId,
  disabled,
}) => {
  const generatedId = useId();
  const handleChange = useCallback(() => {
    if (onChange) {
      onChange(!checked);
    }
  }, [checked, onChange]);
  const id = customId || generatedId;

  const handleKeyUp: KeyboardEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      if (e.key === 'Enter') {
        handleChange();
      }
    },
    [handleChange]
  );

  return (
    <label htmlFor={id} className={'flex flex-row items-center gap-2 ' + className}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={handleChange}
        onKeyUp={handleKeyUp}
        disabled={disabled}
      />
      <span className="text-sm">{label}</span>
    </label>
  );
};

export default Checkbox;
